import React, { Suspense, lazy, useEffect, useRef, useState } from "react";
import { Hero } from "./Hero";

const Services = lazy(() => import("./Services").then((m) => ({ default: m.Services })));
const Reviews = lazy(() => import("./Reviews").then((m) => ({ default: m.Reviews })));
const About = lazy(() => import("./About").then((m) => ({ default: m.About })));
const ServiceAreas = lazy(() => import("./ServiceAreas").then((m) => ({ default: m.ServiceAreas })));
const Pricing = lazy(() => import("./Pricing").then((m) => ({ default: m.Pricing })));
const Contact = lazy(() => import("./Contact").then((m) => ({ default: m.Contact })));

const LazySection = ({ children, targetId }) => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const node = sectionRef.current;
    if (!node || isVisible) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: "250px 0px" }
    );

    observer.observe(node);

    return () => observer.disconnect();
  }, [isVisible]);

  useEffect(() => {
    const revealSection = (event) => {
      if (event.detail?.id === targetId) {
        setIsVisible(true);
      }
    };

    window.addEventListener("reveal-section", revealSection);

    return () => window.removeEventListener("reveal-section", revealSection);
  }, [targetId]);

  return (
    <div ref={sectionRef}>
      {isVisible ? (
        <Suspense fallback={<div style={{ minHeight: "160px" }} aria-hidden="true" />}>
          {children}
        </Suspense>
      ) : (
        <div style={{ minHeight: "160px" }} aria-hidden="true" />
      )}
    </div>
  );
};

export const Home = () => {
  return (
    <>
      <Hero />
      <LazySection targetId="services">
        <Services />
      </LazySection>
      <LazySection targetId="reviews">
        <Reviews />
      </LazySection>
      <LazySection targetId="about">
        <About />
      </LazySection>
      <LazySection targetId="service-areas">
        <ServiceAreas />
      </LazySection>
      <LazySection targetId="pricing">
        <Pricing />
      </LazySection>
      <LazySection targetId="contact">
        <Contact />
      </LazySection>
    </>
  );
};
